export const BUILD_INFO = { sha: 'c978701' };
